import Axios from 'axios';
import { apiUrl } from './dataProvider';

const xApiKey = 'f5eb1e0c-f909-11ea-adc1-0242ac120002';

const AuthProvider = {
  login: async ({ username, password }) => {
    await Axios.post(
      `${apiUrl}/login`,
      JSON.stringify({
        method: 'phone',
        token: password,
        areaCode: '1',
        phone: username,
      }),
      {
        headers: {
          'x-api-key': xApiKey,
          'Content-Type': 'application/json',
        },
      }
    ).then((res) => {
      if (res.data.token && res.data.userId) {
        localStorage.setItem('token', res.data.token);
        localStorage.setItem('userId', res.data.userId);
        localStorage.removeItem('not_authenticated');
        return Promise.resolve();
      } else {
        localStorage.setItem('not_authenticated', true);
        return Promise.reject();
      }
    });
  },
  logout: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('userId');
    localStorage.setItem('not_authenticated', true);

    return Promise.resolve();
  },
  checkError: ({ status }) => {
    return status === 401 || status === 403
      ? Promise.reject()
      : Promise.resolve();
  },
  checkAuth: () => {
    return localStorage.getItem('not_authenticated')
      ? Promise.reject()
      : Promise.resolve();
  },
  getPermissions: () => {
    const token = localStorage.getItem('token');
    return Promise.resolve(token);
  },
  getIdentity: () => {
    return {
      id: localStorage.getItem('userId'),
    };
  },
};

export default AuthProvider;
